import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import QuickEntry from '@/pages/home/components/QuickEntry';
import StatsOverview from '@/pages/home/components/StatsOverview';
import PlatformIntro from '@/pages/home/components/PlatformIntro';
import CoursesSection from '@/pages/home/components/CoursesSection';
import HospitalsSection from '@/pages/home/components/HospitalsSection';
import DiseasesSection from '@/pages/home/components/DiseasesSection';
import AchievementsSection from '@/pages/home/components/AchievementsSection';
import ActivitiesSection from '@/pages/home/components/ActivitiesSection';
import VideosSection from '@/pages/home/components/VideosSection';
import DoctorsSection from '@/pages/home/components/DoctorsSection';
import PartnersSection from '@/pages/home/components/PartnersSection';
import CtaBanner from '@/pages/home/components/CtaBanner';

export default function Home() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // Only honour `scrollTo` on a forward (PUSH) navigation. Back/forward is a
    // restoration of an existing entry: replaying a stale target here would
    // send the user to that section (e.g. the contact banner at the bottom)
    // every time they return to the home page from a detail page.
    if (navigationType !== 'PUSH') return undefined;
    const target = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (!target) return undefined;
    const timer = setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
    }, 120);
    return () => clearTimeout(timer);
  }, [location.key, location.state, navigationType]);

  return (
    <div className="w-full min-h-screen bg-background-50 font-body">
      <Navbar />
      <main>
        <HeroCarousel />
        <QuickEntry />
        <StatsOverview />
        <PlatformIntro />
        <ActivitiesSection />
        <CoursesSection />
        <HospitalsSection />
        <DiseasesSection />
        <AchievementsSection />
        <VideosSection />
        <DoctorsSection />
        <PartnersSection />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}